import {ClaimFilters} from 'Agent/Claims/ducks/claim';
import {map as mapEither} from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import {addFilterParameters} from 'Shared/utilities/addFilterParameters';
import {get} from 'Shared/utilities/fetchHelpers';

export const claimRootUri = '/claims/policies';

export default {
  getClaims: (
    agentNumbers: string[],
    isNewYork: boolean,
    encryptedIdentifier: string,
    policyId: string,
    filter?: ClaimFilters
  ) =>
    get<any>(
      `${claimRootUri}/${policyId}${addFilterParameters({agentNumbers, isNewYork, encryptedIdentifier, ...filter})}`
    ).then(itemsEither =>
      pipe(
        itemsEither,
        mapEither(items => ({
          currentPageNumber: 0,
          links: [],
          result: items,
          totalCount: items.length,
        }))
      )
    ),
};
